let _format = (v) => `₹${v || 0}`;
let _symbol = '₹';
let _code = 'INR';

export const setCurrencyHelpers = (fmt, sym, code) => {
  _format = fmt;
  _symbol = sym;
  _code = code;
};

export const formatMoney = (amount) => _format(amount);
export const currencySymbol = () => _symbol;
export const currencyCode = () => _code;

export const CURRENCY_SYMBOLS = {
  INR: '₹', USD: '$', EUR: '€', GBP: '£', AED: 'د.إ', SGD: 'S$',
  AUD: 'A$', CAD: 'C$', JPY: '¥', THB: '฿', MYR: 'RM', LKR: 'Rs',
  NZD: 'NZ$',
  NPR: 'Rs', BDT: '৳', PKR: 'Rs',
};

export const fmtMoney = (amount, code = 'INR') => {
  const sym = CURRENCY_SYMBOLS[code] || '';
  const n = Number(amount || 0);
  return `${sym}${n.toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
};
